export interface IPlatformSocialData {
  readonly id?: number
  name?: string
  ref?: string
}

export interface IPlatformSocial extends IPlatformSocialData {
  name: string
  ref?: string
  validate(): boolean

  key: string
}

export const PLATFORM_SOCIAL_NAME_MAX_LENGTH = 50
